import Pagination from '@/components/Pagination';
import CreditorDialog from '@/components/creditorDialog';
import { getUserList, editUser, addUser, deleteUser, enablerOutUser, getUserCount,getUserMsgCount,setUserMsgCount } from '@/serve/user';
export default {
    components: {
        Pagination,
        CreditorDialog
    },
    data() {
        let checkPhone = (rule, value, callback) => {
            let reg = /^1[3456789]\d{9}$/;
            if (!reg.test(value)) {
                callback(new Error('请输入11位手机号'));
            } else {
                callback();
            }
        };
        return {
            isEdit: true,
            total: 0,
            ids: [],
            multipleSelection: [],
            loading: false,
            tableLoading: false,
            userId: '',
            // 管理用户信息
            adminForm: {
                name: '',
                page: 0,
                rows: 20,
                ban: '',
                type: 'MANAGER',
                username: ''
            },
            creditorDialogVisible: false,
            editUserForm: {
                name: '',
                username: '',
                cypher: '',
                phone: '',
                certificateType: 'COMPANY',
                type: 'MANAGER',
				noteNumber:'',
            },
            rules: {
                name: [
                    {
                        required: true,
                        message: '请填写管理人机构名称',
                        trigger: 'blur'
                    }
                ],
                username: [
                    {
                        required: true,
                        message: '请填写社会统一信息代码',
                        trigger: 'blur'
                    }
                ],
                cypher: [
                    {
                        required: true,
                        message: '请填写密码',
                        trigger: 'blur'
                    }
                ],
                // phone: [
                //     {
                //         required: true,
                //         type: 'number',
                //         validator: checkPhone,
                //         message: '请输入11位有效手机号号码',
                //         trigger: ['blur']
                //     }
                // ],
				// noteNumber:[
				// 	{
				// 	    required: true,
				// 	    message: '请输入可用短信条数',
				// 	    trigger: 'blur'
				// 	}
				// ]
            },
			ruless: {
			    name: [
			        {
			            required: true,
			            message: '请填写代理人姓名',
			            trigger: 'blur'
			        }
			    ],
			    username: [
			        {
			            required: true,
			            message: '请填写证件号码',
			            trigger: 'blur'
			        }
			    ],
			    cypher: [
			        {
			            required: true,
			            message: '请填写密码',
			            trigger: 'blur'
			        }
			    ],
			    phone: [
			        {
			            required: true,
			            type: 'number',
			            validator: checkPhone,
			            message: '请输入11位有效手机号号码',
			            trigger: ['blur']
			        }
			    ]
			},
            managerDialogVisible: false,
            options: [
                {
                    value: '',
                    label: '全部'
                },
                {
                    value: true,
                    label: '停用'
                },
                {
                    value: false,
                    label: '启用'
                }
            ],
            tableData: [],
			resetDisabled:false
        };
    },
    created() {
        // if (/agentList/.test(window.location.hash)) {
        //     this.adminForm.type = 'AGENT';
        //     this.editUserForm.type = 'AGENT';
        // }
		if(/creditorList/.test(window.location.hash)) {
			    this.adminForm.type = 'CREDITOR,AGENT';
			    this.editUserForm.type = 'CREDITOR,AGENT';
		}
        this.getUserList();
    },
    methods: {
        cancelVisible() {
            this.creditorDialogVisible = false;
        },
        // 选中项
        handleSelectionChange(val) {
            this.multipleSelection = val;
            this.ids = this.multipleSelection.map(item => item.id);
        },
        // 翻页
        turnPage(attr, val) {
            this.adminForm[attr] = val;
            this.getUserList();
        },
        // 新增用户
        addUser() {
            this.editUserForm = {
                name: '',
                username: '',
                phone: '',
                cypher: '',
                certificateType: 'COMPANY',
                type: 'MANAGER',
				noteNumber:'',
            };
            this.isEdit = false;
            this.managerDialogVisible = true;
        },
        // 编辑用户
        async editUser(row, type,ss) {
            this.isEdit = true;
            this.userId = row.id;
            this.editUserForm = {
                ...row,
				noteNumber:'',
            };
			if(ss == '管理人'){
				this.editUserForm.noteNumber = await getUserMsgCount(this.userId);
			}
            if (type == 'creditor') {
                this.creditorDialogVisible = true;
            } else {
                this.managerDialogVisible = true;
            }
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        deleteUser(id) {
            let userIds = [id];
            this.$confirm('此操作将永久删除该债权人, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                customClass: 'del-model',
                type: 'warning'
            }).then(() => {
                deleteUser({
                    userIds
                })
                    .then(() => {
                        this.$message.success('删除成功');
                        this.getUserList();
                    })
                    .catch(err => {
                        if (err.status == 400) {
                            this.$message.error(err.data.message);
                        }
                    });
            });
        },
        sureEditManager(formName, isEdit = true) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.loading = true;
					console.log("this.editUserForm.noteNumber",this.editUserForm.noteNumber)
					setUserMsgCount(this.userId,this.editUserForm.noteNumber)
					        .then((res) => {
								console.log("res",res)
					        })
					        .catch(err => {
					        });
                    if (isEdit) {
                        editUser(this.userId, this.editUserForm)
                            .then(() => {
                                this.$message.success('编辑成功');
                                this.managerDialogVisible = this.loading = false;
                                this.getUserList();
                            })
                            .catch(err => {
                                this.managerDialogVisible = this.loading = false;
                                this.$message.error(err.data.message);
                            });
                    } else {
                        addUser(this.editUserForm)
                            .then(() => {
                                this.resetForm(formName);
                                this.$message.success('创建成功');
                                this.managerDialogVisible = this.loading = false;
                                this.getUserList();
                            })
                            .catch(err => {
                                this.$message.error(err.data.message);
                                this.managerDialogVisible = this.loading = false;
                            });
                    }
					
                }
            });
        },
        // 批量启用/停用
        batchEable(ban) {
            if (!this.ids.length) {
                return this.$message.warning('请先选中数据');
            }
            this.enableoroutManager(ban, ...this.ids);
        },
        enableoroutManager(ban, ...ids) {
            let msg = ban ? '停用' : '启用';
            let userIds = ids;
            enablerOutUser({
                ban,
                userIds
            })
                .then(() => {
                    this.$message.success(`${msg}成功`);
                    this.getUserList();
                })
                .catch(err => {
                    this.$message.error(err.data.message);
                });
        },
        onSearch() {
            this.adminForm.page = 0;
            this.adminForm.rows = 20;
            this.getUserList();
        },
		reset() {
			this.adminForm.username = '';
			this.adminForm.name = '';
			this.adminForm.ban = '';
			this.resetDisabled = true;
			this.getUserList();
		},
		resetStyle() {
			let type = false;
			if (this.adminForm.name != '' ||this.adminForm.username != ''||this.adminForm.ban != '') {
				type = true;
				this.resetDisabled = false;
			}
			let color = type ? "#282D30" : "rgba(0,0,0,0.4)"
			return {
				color: color
			}
		},
		
        // 获取用户列表
        async getUserList() {
            this.tableLoading = true;
            this.total = await getUserCount(this.adminForm);
            if (this.total > 0) {
                this.getManorAreaList();
            } else {
                this.tableLoading = false;
                this.tableData = [];
            }
        },
        getManorAreaList() {
            getUserList(this.adminForm)
                .then(res => {
                    for (let i = 0; i < res.length; i++) {
                        res[i].num = i + 1;
                    }
                    this.tableData = res;
                    this.tableLoading = false;
                })
                .catch(err => {
                    this.tableLoading = false;
                    this.$message.error('获取用户列表失败');
                });
        }
    }
};
